import { render, staticRenderFns } from "./TheGroups.vue?vue&type=template&id=766af476&"
import script from "./TheGroups.vue?vue&type=script&lang=js&"
export * from "./TheGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports